<template>
  <div class="contents">
    <b-modal ref="siteModal" id="site-modal" class="siteModal" hide-footer hide-header>
      <div class="d-block text-center">
        <div class="site-heading">
          Choose a site for the selected study.
          <button type="button" class="close" @click="hide">&times;</button>
        </div>
        <div>
          <input v-model="siteName" placeholder="Select Site" @click="showDropDown()" class="selectSite caret-down-icon" />
        </div>
        <div class="tbl-div">
          <div class="table-responsive">
            <table class="table table-borderless" v-if="isDropDownShow">
              <thead>
                <tr>
                  <th class="tbl-head">Site Id</th>
                  <th class="tbl-head">Site Name</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="site in sites" :key="site.id" @click="onSiteSelect(site)">
                  <td>
                    <span :title="site.userSiteId" v-if="site.userSiteId.length >= 9">{{ site.userSiteId.slice(0, 8) }}..</span>
                    <span v-if="site.userSiteId.length < 9">{{ site.userSiteId }}</span>
                  </td>
                  <td>
                    <span :title="site.name" v-if="site.name.length >= 28">{{ site.name.slice(0, 27) }}..</span>
                    <span v-if="site.name.length < 28">{{ site.name }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <button class="btn btn-primary continue-btn" :class="{ disabled: !isSiteTeamSelected }" @click="onClickContinue()">
        Continue
      </button>
    </b-modal>
  </div>
</template>

<script>
import { INTERVIEWER } from "@/constants/authRoles";
import { mapGetters } from "vuex";
export default {
  name: "sitelistmodal",
  props: ["siteList"],
  watch: {
    siteList: function(newVal) {
      this.sites = newVal;
    }
  },
  data() {
    return {
      sites: [],
      isDropDownShow: false,
      siteName: "",
      userRole: "",
      site: {},
      isSiteTeamSelected: false
    };
  },
  mounted() {
    this.sites = this.siteList;
  },
  computed: {
    ...mapGetters(["user"]),
    canInterviewerAccess() {
      this.$acl.change(`${INTERVIEWER}`);
      return this.$acl.check("userAccess");
    }
  },
  methods: {
    show() {
      this.isSiteTeamSelected = false;
      this.$refs.siteModal.show();
    },
    hide() {
      this.$refs.siteModal.hide();
    },
    showDropDown() {
      this.isDropDownShow = true;
    },
    onSiteSelect(site) {
      this.isSiteTeamSelected = true;
      this.site = site;
      this.siteName = site.name;
      this.isDropDownShow = false;
      this.$store.state.selectedSite = site;
      localStorage.setItem("selectedSite", site.id);
    },
    onClickContinue() {
      this.$emit("continueChild", this.site.id);
      this.$refs.siteModal.hide();
    }
  }
};
</script>

<style scoped lang="scss" src="../../../public/static/fonts.scss"></style>
<style scoped lang="scss">
.selectSite {
  width: 360px;
  height: 40.7px;
  padding: 8px 6px 5.7px 8px;
  border-radius: 3px;
  border: solid 2px #d3dfe4;
  cursor: pointer;
}
th,
td {
  padding: 0px !important;
}
tr {
  line-height: 25px;
}
.table-borderless > tbody > tr > td,
.table-borderless > tbody > tr > th,
.table-borderless > tfoot > tr > td,
.table-borderless > tfoot > tr > th,
.table-borderless > thead > tr > td,
.table-borderless > thead > tr > th {
  border: none !important;
}
.table-borderless {
  margin: 0px 0px 0px 12px;
}
.site-heading {
  width: 440px;
  height: 47px;
  margin: 0 0 3px;
  font-family: Roboto-Regular;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.28;
  letter-spacing: normal;
  text-align: center;
  color: #666669;
}
.continue-btn {
  margin-left: 148px !important;
  margin-bottom: 15px !important;
  margin-top: 35px !important;
  width: 150px;
  height: 36px;
  margin: 30px 145px 0;
  padding: 6px 16px;
  background-color: #4c8ce4;
  border-radius: 20px;
  font-family: Roboto-Regular;
  font-size: 14px;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}
.siteModal {
  max-height: 200px !important;
  min-height: 180px !important;
}
.caret-down-icon {
  background-image: url(/static/img/caret-down.png);
  background-position: 324px 7px;
  background-repeat: no-repeat;
}
.tbl-div {
  position: absolute;
  top: 60px;
  z-index: 1;
}
.disabled {
  opacity: 0.5;
  pointer-events: none;
}

table tbody {
  height: 80px;
  overflow-y: scroll;
}
.table-responsive {
  display: block;
  width: 360px;
  max-height: 130px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.4);
  margin: 5px 41.5px 3px 42px;
  text-align: left;
}

.table-responsive::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

.table-responsive::-webkit-scrollbar-thumb {
  background-color: #b0bac9;
  border: 2px solid #b0bac9;
  border-radius: 4px;
}
.tbl-head {
  font-family: Roboto-Regular;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  color: #b0bac9;
}
</style>
